import { Formik } from "formik";
import React from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Auth } from "aws-amplify";
import ForgotPasswordSchema from "./validation schema/ForgotPasswordSchema";
import HelmetMetaData from "../HelmetMetaData";

function ForgotPassword() {
    async function forgotpassword(data) {
        try {
            const { email } = data;
            // console.log(email)
            await Auth.forgotPassword(email);
            window.location.href = "/confirm-reset/";
        } catch (e) {
            alert("Something went wrong, please try again." + e)
        }
    }
    return (
        <div className="account">
            <HelmetMetaData
                title="Innov-Edu Certificate | Forgot Password"
                description="Reset your certificate account password."
            ></HelmetMetaData>
            <Row style={{ width: "100%", margin: "0" }}>
                <Col md={6} sm={12}>
                    <Container id="login-container">
                        <h1>Reset Your Password</h1>
                        <p>Enter your email to get instructions to reset your password.</p>
                        <Formik
                            validationSchema={ForgotPasswordSchema}
                            onSubmit={(data, { setSubmitting }) => {
                                setSubmitting(true);
                                forgotpassword(data);
                                // console.log("Submit: ", data);
                                setSubmitting(false);
                            }}
                            initialValues={{
                                email: '',
                                password: '',
                            }}
                        >{({
                            handleSubmit,
                            handleChange,
                            isSubmitting,
                            values,
                            touched,
                            errors,
                            isValid
                        }) => (
                            <Form onSubmit={handleSubmit}>
                                <Row md={1}>
                                    <Col sm={12}>
                                        <Form.Group className="auth-input">
                                            <Form.Label>Email address</Form.Label>
                                            <Form.Control
                                                type="email"
                                                name="email"
                                                value={values.email}
                                                onChange={handleChange}
                                                placeholder="Email"
                                                isValid={touched.email && !errors.email}
                                                isInvalid={!!errors.email}
                                                id="email"
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.email}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                    {/* <Form.Group className="auth-input">
                                <Form.Label>Password</Form.Label>
                                <Form.Control
                                    type="password"
                                    name="password"
                                    value={values.password}
                                    onChange={handleChange}
                                    placeholder="Password"
                                    isValid={touched.password && !errors.password}
                                    isInvalid={!!errors.password}
                                    id="password"
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.password}
                                </Form.Control.Feedback>
                            </Form.Group> */}
                                </Row>
                                <Button
                                    disabled={isSubmitting}
                                    className="mt-3 btn-form btn-login"
                                    variant="primary"
                                    type="submit"
                                >
                                    Send Email
                                </Button>
                            </Form>
                        )}
                        </Formik>
                    </Container>
                </Col>
                <Col id="reg-img" md={6} sm={12}>
                    <div id="register-container">
                        <h1>Already sent a code?</h1>
                        <p>Set your new password here!</p>
                        <Button
                            //   disabled={!isEnabled}
                            className="mt-3 btn-reg"
                            // variant="primary"
                            href="/confirm-reset"
                        >
                            RESET PASSWORD
                        </Button>
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default ForgotPassword;